import React from 'react';
import { Typography, makeStyles, Box } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '15px 20px',
    border: '1px solid #eee',
    borderWidth: '1px 0',
    background: 'white',
    marginTop: 0,
  },
  title: {
    fontSize: 24
  }
}));

const Header = ({
  title,
  children,
  calendar
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.root} display="flex" justifyContent="space-between" alignItems="center">
      <Typography className={classes.title}>
        {title}
      </Typography>
      {calendar}
      {children}
    </Box>
  );
};

Header.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node
};

Header.defaultProps = {
  title: '',
};

export default Header;